import * as actionTypes from './actionTypes';

const initialState = {
  activities: {},
  error: { activityError: false, message: '' }
};

const handleRemoveActivity = (state, activityId) => {
  const activities = { ...state.activities }; // Creates a copy of activities in state
  const entries = activities.activities.entries;
  const activityIndex = entries.findIndex(activity => activity.activityId === activityId);
  entries.splice(activityIndex, 1); // Remove activity from the copy
  return activities; // Return new activities property, without mutate the state
};

const handleUpdateActivity = (state, modifiedActivity) => {
  const activities = { ...state.activities }; // Creates a copy of activities in state
  const entries = activities.activities.entries;
  const activityIndex = entries.findIndex(activity => activity.activityId === modifiedActivity.activityId);
  entries.splice(activityIndex, 1, modifiedActivity); // Replace activity at index
  return activities;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACTIVITIES_SUCCESS:
      return { ...state, activities: action.activities };
    case actionTypes.FETCH_ACTIVITIES_FAILURE:
      return { ...state, error: { activity: true, messages: action.messages } };
    case actionTypes.UPDATE_CALENDAR_ACTIVITIES: {
      return { ...state, activities: action.activities.activities, types: action.activities.types };
    }
    case actionTypes.REMOVE_ACTIVITY: {
      const activities = handleRemoveActivity(state, action.activityId);
      return { ...state, activities };
    }
    case actionTypes.UPDATE_ACTIVITY: {
      const activities = handleUpdateActivity(state, action.activity);
      return { ...state, activities };
    }
    default:
      return state;
  }
};

export { reducer as default };
